// IANA timezone identifiers for tenant-timezone dropdowns.
// Uses the browser's built-in list when available so it stays in sync with
// what the backend (Python zoneinfo) validates against; falls back to a
// curated common set for older browsers.
const FALLBACK = [
  "UTC",
  "Africa/Abidjan", "Africa/Cairo", "Africa/Kinshasa", "Africa/Lagos",
  "Africa/Johannesburg", "Africa/Nairobi", "Africa/Casablanca",
  "Europe/London", "Europe/Paris", "Europe/Berlin", "Europe/Madrid",
  "Europe/Moscow", "Europe/Istanbul",
  "America/New_York", "America/Chicago", "America/Denver",
  "America/Los_Angeles", "America/Sao_Paulo", "America/Mexico_City",
  "America/Toronto", "America/Bogota",
  "Asia/Dubai", "Asia/Karachi", "Asia/Kolkata", "Asia/Dhaka",
  "Asia/Bangkok", "Asia/Shanghai", "Asia/Tokyo", "Asia/Singapore",
  "Australia/Sydney", "Australia/Perth", "Pacific/Auckland",
];

export const IANA_TIMEZONES = (() => {
  let list = FALLBACK;
  try {
    if (typeof Intl !== "undefined" && typeof Intl.supportedValuesOf === "function") {
      const v = Intl.supportedValuesOf("timeZone");
      if (Array.isArray(v) && v.length) list = v;
    }
  } catch (e) {
    /* keep fallback */
  }
  // Guarantee UTC is selectable and sits first.
  return ["UTC", ...list.filter((z) => z !== "UTC")];
})();
